<template>
    <div style="height:100%" class="points-show">
        <el-menu class="el-menu-vertical-demo" router :unique-opened="true" :default-active="$route.path"
            :collapse="isCollapse">
            <div v-for="(item, index) in menuList" :key="index">
                <el-menu-item :index="item.path" v-if="item.sysAuths == null">
                    <i :class="item.icon"></i>
                    <span slot="title" v-if="!isCollapse">{{ item.authName }}</span>
                </el-menu-item>
                <el-submenu :index="'menu' + index" v-if="item.sysAuths != null">
                    <template slot="title">
                        <i :class="item.icon"></i>
                        <span style="padding-left: 0px;" v-if="!isCollapse">{{ item.authName }}</span>
                    </template>
                    <el-menu-item :index="son.path" v-for="(son, index) in (item.sysAuths)" :key="index">
                        <template slot="title">
                            <span style="padding-left: 18px;">{{ son.authName }}</span>
                        </template>
                    </el-menu-item>
                </el-submenu>
            </div>
        </el-menu>
    </div>
</template>
<script>
export default {
    data() {
        return {
            asideNav: [],
            menuList: [],
            isCollapse: false
        };
    },
    created() {
        this.InitMenu();
    },
    methods: {
        switchCard() {
            this.isCollapse = !this.isCollapse;
            this.$emit('switchAsideNavHd');
        },
        InitMenu() {
            if (this.$store.state.addRoutes) {
                this.menuList = this.$store.state.addRoutes;
            } else {
                this.$router.push({
                    path: '/login'
                })
            }
        },
    }
};
</script>
<style>
/deep/ .el-menu .el-menu--inline {
    height: 100%;
}

.el-menu {
    height: auto;
    /* height: 1300px; */
    min-height: 100%;
    overflow: hidden;
}

el-menu-item-group {
    background-color: red;
}

.iconfont {
    font-weight: normal;
    font-size: 18px;
    margin-right: 8px;
    color: #e6e6e6;
}

.el-submenu__title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.el-menu-item {
    height: auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
}
</style>
